import {handleActions} from 'redux-actions'
import * as type from './type'
import {LOCATION_CHANGE} from 'connected-react-router'
import {DEFINED_IMAGE_LIST} from '../detail/const'

export const initialState = {
    imageVersionList: {},
    fetching: false,
    error: null,
    showImages: true,
    uploadingImages: {},
    retryImages: {},
    selectedImageType: DEFINED_IMAGE_LIST[10],
    currentStep: -1,
    slideIndex: null,
}

export default handleActions(
    {
        [LOCATION_CHANGE]: (state, action) => {
            return {
                ...initialState,
            }
        },
        [type.TOGGLE_IMAGE_VIEW]: (state, action) => {
            return {
                ...state,
                showImages: !state.showImages,
            }
        },
        [type.FIND_IMAGE_VERSION_LIST_REQUEST]: (state, action) => {
            return {
                ...state,
                imageVersionList: {},
                fetching: true,
                error: null,
            }
        },
        [type.FIND_IMAGE_VERSION_LIST_SUCCESS]: (state, action) => {
            const { imageVersionList } = action.payload
            return {
                ...state,
                imageVersionList,
                fetching: false,
            }
        },
        [type.FIND_IMAGE_VERSION_LIST_ERROR]: (state, action) => {
            const { error } = action.payload
            return {
                ...state,
                fetching: false,
                error,
            }
        },

        [type.UPLOAD_CUSTOMER_IMAGE_REQUEST]: (state, action) => {
            const { fileName } = action.payload
            const uploadingImages = state.uploadingImages
            uploadingImages[fileName] = true
            return {
                ...state,
                uploadingImages,
            }
        },
        [type.UPLOAD_CUSTOMER_IMAGE_SUCCESS]: (state, action) => {
            const { imageVersionList, fileName } = action.payload
            const uploadingImages = state.uploadingImages
            uploadingImages[fileName] = false
            const retryImages = state.retryImages
            retryImages[fileName] = false
            return {
                ...state,
                imageVersionList,
                fetching: false,
                uploadingImages,
                retryImages,
            }
        },
        [type.REUPLOAD_CUSTOMER_IMAGE_SUCCESS]: (state, action) => {
            const { fileAdded, imageType } = action.payload
            const uploadingImages = state.uploadingImages
            uploadingImages[imageType] = false
            const retryImages = state.retryImages
            retryImages[imageType] = false
            return {
                ...state,
                imageVersionList: {
                    ...state.imageVersionList,
                    [imageType]: fileAdded,
                },
                fetching: false,
                uploadingImages,
            }
        },
        [type.UPLOAD_CUSTOMER_IMAGE_ERROR]: (state, action) => {
            const { fileName } = action.payload
            const uploadingImages = state.uploadingImages
            uploadingImages[fileName] = false
            const retryImages = state.retryImages
            retryImages[fileName] = true
            return {
                ...state,
                uploadingImages,
                retryImages,
            }
        },
        [type.ROTATE_CUSTOMER_IMAGE_REQUEST]: (state, action) => {
            const { fileName, versionId, targetDegree } = action.payload

            const imageVersion = state.imageVersionList[fileName].map(
                version => {
                    if (version.versionId !== versionId) {
                        return version
                    }
                    const meta = version.meta
                        ? version.meta
                        : {
                            rotate: 0,
                        }
                    meta.rotate = targetDegree
                    return {
                        ...version,
                        meta,
                    }
                }
            )

            return {
                ...state,
                imageVersionList: {
                    ...state.imageVersionList,
                    [fileName]: imageVersion,
                },
            }
        },
        [type.SET_IMAGE_TYPE_META_DATA_SUCCESS]: (state, action) => {
            const { imageType, versionId, newImageType } = action.payload
            const imageVersion = state.imageVersionList[imageType].map(
                version => {
                    if (version.versionId !== versionId) {
                        return version
                    }
                    const meta = version.meta
                        ? version.meta
                        : {
                            imageType: newImageType,
                        }
                    meta.imageType = newImageType
                    return {
                        ...version,
                        meta,
                    }
                }
            )

            return {
                ...state,
                imageVersionList: {
                    ...state.imageVersionList,
                    [imageType]: imageVersion,
                },
            }
        },
        [type.SET_SELECTED_IMAGE_TYPE]: (state, action) => {
            const { selectedImageTypeName } = action.payload
            const selectedImageType = DEFINED_IMAGE_LIST.find(item => item.name === selectedImageTypeName)
            return {
                ...state,
                selectedImageType,
            }
        },
        [type.SET_CURRENT_STEP]: (state, action) => {
            const { currentStep } = action.payload
            return {
                ...state,
                currentStep,
            }
        },
        [type.SET_SLIDE_INDEX]: (state, action) => {
            const { slideIndex } = action.payload
            return {
                ...state,
                slideIndex,
            }
        },
        [type.DELETE_CUSTOMER_IMAGE_REQUEST]: (state, action) => {
            return {
                ...state
            }
        },
        [type.DELETE_CUSTOMER_IMAGE_SUCCESS]: (state, action) => {
            const { imageType, versionId } = action.payload
            const imageVersion = state.imageVersionList[imageType].filter(
                version => version.versionId !== versionId
            )

            return {
                ...state,
                imageVersionList: {
                    ...state.imageVersionList,
                    [imageType]: imageVersion,
                },
            }
        },
        [type.DELETE_CUSTOMER_IMAGE_ERROR]: (state, action) => {
            const { error } = action.payload
            return {
                ...state,
                error,
            }
        },
    },
    initialState
)



// WEBPACK FOOTER //
// ./src/modules/customer/state/image/reducer.js